// extracted by mini-css-extract-plugin
module.exports = {"settingsLayout":"Settings_settingsLayout__cVzPy"};